import React, { PureComponent, useEffect } from "react";
import {
  Card,
  Badge,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Collapse,
  FormGroup,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { UpdateMobile } from "../general";
import ContentDisplayMobile from "./ContentDisplayMobile";
import { Separator } from "../../../components/common/CustomBootstrap";
import {
  getImageUrl,
  getPlaceholderIcon,
  AddCommaNumber,
} from "../../../helpers/Utils";

class LabelItemLeft extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
      imageError: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems,
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames],
    );
  };

  render() {
    const { dropdownSplitOpen, imageError } = this.state;
    const {
      make_products,
      data_stocks,
      item,
      toggleAccordion,
      accordion,
      idx,
      setting,
      selectedItems,
      isDisabledUpdate,
      isDisabledDelete,
      onUpdate,
      onChangeCheckbox,
      onBestter,
      onSoftHide,
      onDelete,
      onChange,
      sku,
      business_type,
    } = this.props;
    const imageUrl = getImageUrl(item.image);
    return (
      <div className="custom-shadow">
        <div className="d-flex flex-row cursor-pointer">
          <div
            className={classnames("d-flex flex-grow-1 min-width-zero", {
              disable: item.softHide ? "disable" : "",
            })}
          >
            {/* Product Image */}
            <div
              className={classnames("d-block position-relative", {
                disable: item.softHide,
              })}
              style={{ flexShrink: 0 }}
            >
              {imageError || !imageUrl ? (
                <div className="list-thumbnail responsive border-0 d-flex align-items-center justify-content-center m-1 product-placeholder">
                  <i
                    className={getPlaceholderIcon(
                      business_type,
                      item.fnb_type,
                    )}
                    style={{ fontSize: "50px", color: "#888" }}
                  />
                </div>
              ) : (
                <img
                  alt={item.name}
                  src={imageUrl}
                  onError={() => this.setState({ imageError: true })}
                  className="list-thumbnail responsive border-0 m-1 cursor-pointer product-placeholder"
                  style={{ objectFit: "cover" }}
                />
              )}
              {item.bestter && (
                <Badge
                  className="position-absolute badge-top-right"
                  color="success"
                  pill
                  // style={{ top: 0, right: 0, fontSize: "8px" }}
                >
                  <IntlMessages id="page.heading.best_seller" />
                </Badge>
              )}
            </div>
            <Button
              color=""
              onClick={(e) => {
                const cardEl = e.currentTarget.closest(".custom-shadow");
                toggleAccordion(idx);
                onChangeCheckbox(item.id);
                // Scroll to this card after DOM updates to prevent jump
                setTimeout(() => {
                  if (cardEl) {
                    const navbarHeight =
                      document.querySelector(".navbar")?.offsetHeight || 70;
                    const cardTop =
                      cardEl.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                      top: cardTop - navbarHeight - 10,
                      behavior: "smooth",
                    });
                  }
                }, 350);
              }}
              aria-expanded={accordion[idx]}
              className="flex-grow-1 btn-empty list-item-heading text-left text-one pre-wrap p-0"
            >
              {item.at ? (
                <div
                  onClick={() => {
                    this.onClickedItem(item);
                  }}
                  className={classnames(
                    "card-body align-self-center d-flex flex-ssm-column justify-content-between min-width-zero",
                    {
                      "flex-lg-row align-items-lg-center": !setting.update,
                    },
                  )}
                  style={{ padding: "0.75rem" }}
                >
                  <div className="w-50 list-item-heading mb-1 d-block w-sm-100 text-capitalize">
                    <span>{item.name}</span>
                  </div>
                  <div className="w-50">
                    <Badge color={"primary"} pill="true">
                      {item.at}
                    </Badge>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => {
                    this.onClickedItem(item);
                  }}
                  className="card-body w-100 align-self-center d-flex flex-column justify-content-between min-width-zero"
                  style={{ padding: "0.75rem" }}
                >
                  <div className="list-item-heading mb-1 d-block text-capitalize">
                    {item.name !== "" ? (
                      <span>{item.name}</span>
                    ) : (
                      <span>{`${item.phone}`}</span>
                    )}
                  </div>
                  <p className="text-muted text-small mb-1">SKU: {item.sku}</p>
                  <div>
                    {item.active_sale && parseFloat(item.price_sale) > 0 ? (
                      <>
                        <Badge color="light" pill className="mr-1">
                          <del>{AddCommaNumber(parseFloat(item.price))}</del>
                        </Badge>
                        <Badge color="primary" pill>
                          {AddCommaNumber(parseFloat(item.price_sale))}
                        </Badge>
                      </>
                    ) : (
                      <Badge color="primary" pill>
                        {AddCommaNumber(parseFloat(item.price))}
                      </Badge>
                    )}
                  </div>
                </div>
              )}
            </Button>
          </div>
          {/* Checkbox - outside the disable container */}
          <div
            className="align-self-center pl-0"
            style={{
              padding: "15px 20px",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              onChangeCheckbox(item.id, e);
            }}
          >
            <FormGroup className="mb-0">
              <CustomInput
                type="checkbox"
                id={`check-product-mobile-${item.id}`}
                label=""
                checked={selectedItems.includes(item.id)}
                onChange={() => {}}
              />
            </FormGroup>
          </div>
        </div>

        <Collapse isOpen={accordion[idx]}>
          <div className="card-body accordion-content pt-0 overflow-hidden">
            <Separator />
            <UpdateMobile>
              <ContentDisplayMobile
                // data_dynamic_form={data_dynamic_form}
                // data_tags={this.props.data_tags}
                sku={sku}
                values={item}
                onChange={onChange}
                data_stocks={data_stocks}
                make_products={make_products}
              />
            </UpdateMobile>
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
